import cx from 'classnames'
import { useNavigate } from 'react-router-dom'
import { Message } from 'components'
import style from './Link.module.css'
import useGlobalState from 'hooks/useGlobalState'

const Link = ({
  className = {},
  show = true,
  disabled = false,
  label,
  href,
  icon,
  leftIcon,
  rightIcon,
  children,
  onClick,
  ...props
}) => {
  const { session, local } = useGlobalState()
  const navigate = useNavigate()
  if (!show) return null
  if (!leftIcon) leftIcon = icon

  const getClickProp = () => {
    if (disabled) return { onClick: () => {} }
    if (href) {
      if (href.startsWith('http')) return { href }
      return { onClick: () => navigate(href) }
    }
    return { onClick: () => onClick({ session, local, navigate }) }
  }

  return (
    <a
      className={cx(
        style.link,
        { [style['link--disabled']]: disabled },
        className.link,
        className['link--active'],
      )}
      {...getClickProp()}
      {...props}
    >
      {leftIcon && (
        <div
          className={cx(
            style['link__icon'],
            style['link__icon--left'],
            className['link__icon'],
            className['link__icon--left'],
          )}
        >
          {leftIcon}
        </div>
      )}
      {children || (
        <Message as="div" className={className['link__text']} id={label} />
      )}
      {rightIcon && (
        <div
          className={cx(
            style['link__icon'],
            style['link__icon--right'],
            className['link__icon'],
            className['link__icon--right'],
          )}
        >
          {rightIcon}
        </div>
      )}
    </a>
  )
}

export default Link
